module.exports = __webpack_public_path__ + "static/media/students_1st_access_page_a.1a2d9968.mp3";